import { useSettings } from "../settings/context";

/**
 * HOW WORK GETS SAVED — the organiser's choice, not the event's.
 *
 * Kept in this browser rather than in the event's settings: it says how ONE
 * person likes to work, and storing it on the event would impose it on everyone
 * else who configures the same site.
 *
 * ⚠️ MANUAL MEANS MANUAL. Nothing leaves on a timer, nor when the tab is hidden,
 * nor when organiser mode is left. Someone who asked to decide when their work
 * is sent would not expect it to go anyway the moment they look away — so the
 * browser's own warning covers leaving with unsent work instead.
 *
 * Displayed strings are French: the organiser is a French speaker.
 */
export function SaveMode() {
  const { saveMode, setSaveMode, saving } = useSettings();
  if (!saving) return null;

  return (
    <div className="savemode">
      <span>Enregistrement</span>
      <div className="oseg" role="group" aria-label="Mode d’enregistrement">
        <button
          type="button"
          aria-pressed={saveMode === "auto"}
          onClick={() => setSaveMode("auto")}
        >
          Automatique
        </button>
        <button
          type="button"
          aria-pressed={saveMode === "manual"}
          onClick={() => setSaveMode("manual")}
        >
          Manuel
        </button>
      </div>
    </div>
  );
}
